import { render, staticRenderFns } from "./vendor-label-select.vue?vue&type=template&id=31d2f29a&scoped=true&"
import script from "./vendor-label-select.vue?vue&type=script&lang=js&"
export * from "./vendor-label-select.vue?vue&type=script&lang=js&"
import style0 from "./vendor-label-select.vue?vue&type=style&index=0&id=31d2f29a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2f29a",
  null
  
)

component.options.__file = "vendor-label-select.vue"
export default component.exports